export { default as useAdobeDataLayer } from './adobe-datalayer';
